'use client';

import { useEffect } from 'react';
import { AuthService } from '@/services/auth';

const AuthProvider = ({ children }: { children: React.ReactNode }) => {
  useEffect(() => {
    // Ensure we have a token (either anonymous or authenticated)
    AuthService.ensureToken();
  }, []);

  return <>{children}</>;
};

export default AuthProvider;
